import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  TextField,
  SxProps,
  FormControl,
  FormHelperText,
  Collapse,
} from '@mui/material';
import { useState } from 'react';
import { ASSETS } from '../../const/assets';
import { useContact } from '../../hooks/useContact';
import { Contact } from '../../interface/contact';
const FormRegister = ({
  isSuccess,
  setIsSuccess,
}: {
  isSuccess: boolean;
  setIsSuccess: (isSuccess: boolean) => void;
}) => {
  const [openKey1, setOpenKey1] = useState(false);
  const { mutateAsync: createContact, isPending } = useContact();

  const formik = useFormik({
    initialValues: {
      fullName: '',
      email: '',
      phoneNumber: '',
      companyName: '',
      address: '',
      select: '',
    },
    validationSchema: Yup.object({
      fullName: Yup.string().trim().required('Họ tên không được để trống'),
      email: Yup.string()
        .trim()
        .email('Email không hợp lệ')
        .required('Email không được để trống'),
      phoneNumber: Yup.string()
        .trim()
        .required('Số điện thoại không được để trống'),
      companyName: Yup.string()
        .trim()
        .required('Tên công ty không được để trống'),
      address: Yup.string().trim().required('Địa chỉ không được để trống'),
      select: Yup.string().required(
        'Hình thức nhận bản tin không được để trống'
      ),
    }),
    onSubmit: async (values) => {
      const contact: Contact = {
        name: values.fullName,
        email: values.email,
        phone: values.phoneNumber,
        company: values.companyName,
        address: values.address,
        receiveMethod: values.select as 'email' | 'print' | 'both',
      };
      try {
        await createContact(contact);
        setIsSuccess(true);
      } catch (error) {
        console.log(error);
      }
    },
  });

  // Style chung cho tất cả các TextField
  const textFieldStyle: SxProps = {
    mb: 2,
    '& .MuiOutlinedInput-root': {
      height: '55px',
      borderRadius: '16px',
      backgroundColor: '#EEEEEE',
      '& fieldset': {
        border: 'none',
      },
      '&.Mui-error fieldset': {
        border: '1px solid #FF0000',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#3E3E3E',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '16px',
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#3E3E3E',
      opacity: 1,
    },
  };

  // Style cho button submit
  const buttonStyle: SxProps = {
    height: '55px',
    borderRadius: '16px',
    fontSize: '16px',
    fontWeight: 'bold',
    mt: 2,
    backgroundColor: formik.isValid && formik.dirty ? '#2A49E2' : '#EEEEEE',
    color: formik.isValid && formik.dirty ? '#FFFFFF' : '#3E3E3E',
    '&:hover': {
      backgroundColor: formik.isValid && formik.dirty ? '#1A39D2' : '#E0E0E0',
    },
    textTransform: 'none',
  };

  return (
    <div className="text-center w-full px-4 md:max-w-[550px] relative z-50">
      {isSuccess ? (
        <div>
          <div className="text-[#85D8FF] text-[60px]">Thank you!</div>
          <div className="text-white text-xl">
            Bản tin sẽ được gửi tới bạn trong thời gian sớm nhất.
          </div>
        </div>
      ) : (
        <>
          <div className="text-xl font-bold text-white mb-2">
            Biểu mẫu đăng ký nhận bản tin
          </div>
          <div className="bg-white rounded-2xl p-5">
            <form onSubmit={formik.handleSubmit}>
              <TextField
                fullWidth
                id="fullName"
                name="fullName"
                placeholder="Họ và tên"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.fullName && Boolean(formik.errors.fullName)
                }
                helperText={formik.touched.fullName && formik.errors.fullName}
                sx={textFieldStyle}
              />
              <TextField
                fullWidth
                id="email"
                name="email"
                placeholder="Email công ty"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                sx={textFieldStyle}
              />
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                placeholder="Số điện thoại"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.phoneNumber &&
                  Boolean(formik.errors.phoneNumber)
                }
                helperText={
                  formik.touched.phoneNumber && formik.errors.phoneNumber
                }
                sx={textFieldStyle}
              />
              <TextField
                fullWidth
                id="companyName"
                name="companyName"
                placeholder="Tên công ty"
                value={formik.values.companyName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.companyName &&
                  Boolean(formik.errors.companyName)
                }
                helperText={
                  formik.touched.companyName && formik.errors.companyName
                }
                sx={textFieldStyle}
              />
              <TextField
                fullWidth
                id="address"
                name="address"
                placeholder="Địa chỉ nhận bản tin (địa chỉ văn phòng)"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
                sx={textFieldStyle}
                InputLabelProps={{ shrink: true }}
              />
              <FormControl
                fullWidth
                margin="normal"
                error={formik.touched.select && !!formik.errors.select}
                className="!mt-0"
              >
                <div
                  className={`w-full rounded-2xl bg-[#EEEEEE]  ${
                    openKey1 ? 'pt-4' : 'py-4'
                  }`}
                  onClick={() => setOpenKey1(!openKey1)}
                  onBlur={() => formik.setFieldTouched('select', true)}
                >
                  <div className="flex items-center justify-between h-full pl-4 pr-5">
                    <span className="text-[16px] text-[#3E3E3E]">
                      {formik.values.select
                        ? formik.values.select === 'email'
                          ? 'Nhận qua Email'
                          : formik.values.select === 'print'
                          ? 'Nhận bản in'
                          : 'Cả 2'
                        : 'Hình thức nhận bản tin'}
                    </span>
                    <img src={ASSETS.icDrop} alt="dropdown icon" />
                  </div>
                  <Collapse in={openKey1}>
                    <div className="bg-[#EEEEEE] rounded-b-2xl py-2 border-t-[0.5px] border-black mt-3">
                      <div
                        className={`px-4 py-2 hover:bg-gray-200 cursor-pointer text-right ${
                          formik.values.select === 'Nhận qua Email'
                            ? 'text-[#2A49E2]'
                            : ''
                        }`}
                        onClick={() => {
                          formik.setFieldValue('select', 'email');
                          setOpenKey1(false);
                        }}
                      >
                        Nhận qua Email
                      </div>
                      <div
                        className={`px-4 py-2 hover:bg-gray-200 cursor-pointer text-right ${
                          formik.values.select === 'Nhận bản in'
                            ? 'text-[#2A49E2]'
                            : ''
                        }`}
                        onClick={() => {
                          formik.setFieldValue('select', 'print');
                          setOpenKey1(false);
                        }}
                      >
                        Nhận bản in
                      </div>
                      <div
                        className={`px-4 pt-2 hover:bg-gray-200 cursor-pointer text-right ${
                          formik.values.select === 'Cả 2'
                            ? 'text-[#2A49E2]'
                            : ''
                        }`}
                        onClick={() => {
                          formik.setFieldValue('select', 'both');
                          setOpenKey1(false);
                        }}
                      >
                        Cả 2
                      </div>
                    </div>
                  </Collapse>
                </div>
                {formik.touched.select && formik.errors.select && (
                  <FormHelperText className="text-red-500">
                    {formik.errors.select}
                  </FormHelperText>
                )}
              </FormControl>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={buttonStyle}
                disabled={isPending}
                loading={isPending}
              >
                Đăng ký
              </Button>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default FormRegister;
